'use client';
import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { ThemeProvider } from 'next-themes';
export const MARKETING_THEME: 'light' | 'system' = 'light';
export function SiteTheme({ children }: { children: ReactNode }) {
  const path = usePathname();
  const app = path === '/home' || path.startsWith('/home/') || path === '/onboarding';
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      forcedTheme={app || MARKETING_THEME === 'system' ? undefined : MARKETING_THEME}
    >
      {children}
    </ThemeProvider>
  );
}
